import store from "../../redux-store";
import { addNcApprovalData, type NcApprovalType } from "../../redux-store/slices/NcApprovalSlice";

const APPROVED = "Approved";
const REJECTED = "Rejected";
export const APPROVE_NON_CHARGEABLE_SALE = "APPROVE_NON_CHARGEABLE_SALE";

export const getNcApprovalStatusData = (mid: string, res: any): NcApprovalType => {
  const isApproved = res.status === APPROVED;
  const isRequested = !isApproved && res.status !== REJECTED;
  const isRejected = res.status === REJECTED;
  return {
    isApproved: isApproved,
    isRequested: isRequested,
    isApprovalRequired: isRejected,
    mid: mid,
    approvalRequestId: res.approvalRequestId,
    currentStatus: res.status,
    requestType: res.requestType,
    approvalData: res
  };
};

const isNcApprovalStageExist = (res: any) => {
  return res.requestType === APPROVE_NON_CHARGEABLE_SALE
}

export const updateNcApprovalState = (data: any, isMyorder = false) => {
  const response = isMyorder ? data : data[0];
  if (response?.approvalRequests && response.approvalRequests.length > 0 && isNcApprovalStageExist(response?.approvalRequests[0])) {
    const ncApprovalData = getNcApprovalStatusData(response.mid, response.approvalRequests[0]);
    store.dispatch(addNcApprovalData(ncApprovalData));
  }
}
